import React, { Component } from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { SafeAreaProvider} from 'react-native-safe-area-context';
import {StatusBar} from 'react-native';
import { serverURL, feUrl } from '../constants/serverURL'
var pako = require('../utils/pako.min.js');
var wasm_exec = require('../utils/wasm_exec.js');
import {  getCache, getCacheCookie} from '../utils/cacheStore.web';
import { showBanner, showInterstitial, showRewardedVideo, closeBanner, showBannerMessage, showInterstitialMessage, closeBannerMessage } from '../utils/admob';
import JsBoard from '../jsboard/JsBoard';

function useJsEngine(): boolean {
    if (typeof window === 'undefined') return false;
    try {
        return new URLSearchParams(window.location.search).get('engine') === 'js';
    } catch {
        return false;
    }
}

// ...


function getHeight() {
    if (Platform.OS  ===  "android"){
        return StatusBar.currentHeight
    } 
    return 30
}  
export default class Game extends Component {
    componentDidMount(): void {
    
    }

    onNavigationStateChange(navState) {
        this.setState({
          canGoBack: navState.canGoBack
        });
    }

    

    getCookie(key){
      const props = window.props;
      var gameMetaString = atob(props.route.params.gm);
      var gameMeta = JSON.parse(gameMetaString);
      if (key == "randomSeed"){
        return String(gameMeta[key])
      } 
      return gameMeta[key];
    }

    load = async () => {
        window.props = this.props;
        window.getCookie = this.getCookie;
        window.showBannerAd = showBannerMessage
        window.showInterstitialAd = showInterstitialMessage
        window.closeBannerAd = closeBannerMessage

        const go = new Go();
        const prefetched = (window as any).__jsdWasmModulePromise as Promise<WebAssembly.Module> | undefined;
        if (prefetched) {
            try {
                console.log("Using prefetched wasm module");
                const mod = await prefetched;
                const instance = await WebAssembly.instantiate(mod, go.importObject);
                go.run(instance);
                console.log("Done (prefetched)");
                return;
            } catch (err) {
                console.warn("Prefetched module unusable, falling back", err);
            }
        }

        console.log("Trying to fetch wasm");
        var buffer = pako.ungzip(await (await fetch("/static/jsd3.wasm.gz", { credentials: "omit" })).arrayBuffer());
        if (buffer[0] === 0x1f && buffer[1] === 0x8b) {
            buffer = pako.ungzip(buffer);
        }
        console.log("Length of buffer: " + buffer.byteLength);
        const result = await WebAssembly.instantiate(buffer, go.importObject);
        go.run(result.instance)
        console.log("Done fetching ");
    }


    render() {
        if (useJsEngine()) {
            return <JsBoard />;
        }

        this.load()

        return (
         <></>
        )

    }
}
{/* <script>
(async function loadAndRunGoWasm() {
    const go = new Go();
    var test = (await fetch("jsd3.wasm.gz")).arrayBuffer();
    var test2 = await test;
    const buffer = pako.ungzip(await (await fetch("jsd3.wasm.gz")).arrayBuffer());


    // A fetched response might be decompressed twice on Firefox.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=610679
    if (buffer[0] === 0x1f && buffer[1] === 0x8b) {
        buffer = pako.ungzip(buffer);
    }
    document.querySelector("#loader-holder").style.display = "none";
    const result = await WebAssembly.instantiate(buffer, go.importObject);
    go.run(result.instance)
})()

</script> */}


{/* <script>


// Polyfill
if (!WebAssembly.instantiateStreaming) {
  WebAssembly.instantiateStreaming = async (resp, importObject) => {
    const source = await (await resp).arrayBuffer();
    return await WebAssembly.instantiate(source, importObject);
  };
}

const go = new Go();
WebAssembly.instantiateStreaming(fetch("jsd3.wasm"), go.importObject).then(result => {
  go.run(result.instance);
});
</script> */}